<template>
    <v-app class="white">
        <!-- 상단타이틀 -->
        <div class="top-bg">
             <!-- 배경 -->
            <img 
            src="@/assets/top_bg.png"
            class="img-top-bg"> 
            <!-- 타이틀 -->
            <div class="top-title-logo">
                {{ $t('password') }}
            </div> 
            <!-- 뒤로가기 버튼 -->
            <div class="top-backkey"
            @click.passive="onClickExit()"
            v-ripple="{ center: true, class: `teal--text`  }">
                <img 
                src="@/assets/backkey.png"
                class="img-backkey"> 
            </div>  
        </div> 
        <div class="logo-img-position">
          <img 
          src="@/assets/intro_logo.png"
          class="img-logo"> 
        </div> 
        <div class="input-position">
           <img 
            src="@/assets/input_bg.png"
            class="img-input-pwd"> 
          <input class="input-pwd-00" type="password" v-model="mPass00" :placeholder=" $t('input_password') ">
        </div>
        <!-- 보내기 -->
        <div class="btn-confirm-postion"
        @click.passive="onClickSend()"
        v-ripple="{ center: true, class: `teal--text`  }"> 
            <div class="txt-center-confirm">입력</div>
        </div>                                                                      
    </v-app>
</template>
<script>
export default {
  created() {
  },
  methods : {
    onClickSend : function() {
      this.$EventBus.$emit('summit_passwd', this.mPass00);
    },
    onClickExit : function() {
      this.$EventBus.$emit('close_passwd', 0);
    }
  },
  data () {
    return {
      mPass00 : "",
    }
  },
}
</script>
<style scoped>
* {
    margin: 0;
    font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
    font-weight: 300;
    padding: 0;
}
html, body {
    height: 100vh;
    width: 100vw;
}
.top-bg {
    position: absolute;
    top: 0vh;
    left: 0vw;
    height: 13.24vw;
    width: 100vw;    
}
.img-top-bg {
    height: 13.24vw;
    width: 100vw;
}
.btn-confirm-postion {
    position: fixed;
    bottom: 0vw; 
    left: 0vw;
    width: 100vw;
    height: 14.35185vw;   
    background-color: #345993;
}
.txt-center-confirm {
    position: absolute;    
    top: 50%;  
    left: 50%;  
    font-family: NanumBarunGothicOTF;
    font-size: 4.1666vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    transform: translate(-50%, -50%);  
    pointer-events: none; 
}
.top-title-logo {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;
}
.img-backkey {
    position: absolute;
    top: 4.07vw;
    left: 5.64vw;
    height: 5.277vw;
    width: 2.77vw;
}
.top-backkey {
    position: absolute;
    top: 0vh;
    left: 0vw;      
    height: 13.24vw;
    width: 13.24vw;
}
.logo-img-position {
    position: absolute;
    top: 39.25vw;
    left: 20.6vw;   
}
.img-logo {
    height: 33.888vw;
    width: 58.888vw;    
}
.img-pwd {
    height: 5.37vw;
    width: 6.11vw;    
}
.pwd-00 {
    position: absolute;
    top: 80.37vw;
    left: 34.4vw;   
}
.pwd-01 {
    position: absolute;
    top: 80.37vw;
    left: 44vw;   
}
.pwd-02 {
    position: absolute;
    top: 80.37vw;
    left: 52.6vw;   
}
.pwd-03 {
    position: absolute;
    top: 80.37vw;
    left: 62vw;   
}
.key-pwd-01 {
    position: absolute;
    bottom: 0vw;
    left: 0vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-02 {
    position: absolute;
    bottom: 0vw;
    left: 33.3vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-03 {
    position: absolute;
    bottom: 0vw;
    left: 66.7vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-04 {
    position: absolute;
    bottom: 15.1vw;
    left: 0vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-05 {
    position: absolute;
    bottom: 15.1vw;
    left: 33.3vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-06 {
    position: absolute;
    bottom: 15.1vw;
    left: 66.7vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-07 {
    position: absolute;
    bottom: 30.2vw;
    left: 0vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-08 {
    position: absolute;
    bottom: 30.2vw;
    left: 33.3vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-09 {
    position: absolute;
    bottom: 30.2vw;
    left: 66.7vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-10 {
    position: absolute;
    bottom: 45.3vw;
    left: 0vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-11 {
    position: absolute;
    bottom: 45.3vw;
    left: 33.3vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.key-pwd-12 {
    position: absolute;
    bottom: 45.3vw;
    left: 66.7vw;   
    width: 33.1vw;
    height: 14.8vw;
    background-color: #e4e4e4;
}
.txt-key-01 {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 4.0vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;
}
.txt-notice-msg {
    position: absolute;
    top: 92.22vw; 
    left: 50%;    
    width: 211px;
    height: 23px;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #231815;
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);     
}
.input-position {
    position: absolute;
    top: 78vw; 
    left: 5vw; 
    height: 10vw;
    width: 88.9vw;
}
.img-input-pwd {
    position: absolute;
    top: 0vw; 
    left: 0vw; 
    height: 8.88vw;
    width: 88.9vw;
}
.input-pwd-00 {
    position: absolute;
    top: 2vw; 
    left: 0vw; 
    width: 88.9vw;
    text-align: center;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #231815;
}
*:focus {
    outline: none;
}
</style>